import GuestProvisioning from "./GuestProvisioning";

export default GuestProvisioning;
